/** Выбор месяца: «‹ Октябрь 2026 ›», месяц и год списками, «Текущий месяц» — вкладки «План» и
 *  «По дням». */
import { ChevronLeft, ChevronRight } from "lucide-react";
import type React from "react";

import { MONTH_NAMES, monthTitle } from "./format";
import { monthOfDay, shiftMonth } from "./planCalc";
import { selectClass } from "./ui";

const YEAR_MIN = 2024;

export function MonthPicker({
  month,
  today,
  onMonth,
  label,
  testId,
}: {
  month: string;
  today: string;
  onMonth: (m: string) => void;
  /** доступное имя группы («Месяц плана») */
  label: string;
  /** data-testid подписи месяца */
  testId: string;
}): React.ReactElement {
  const current = monthOfDay(today);
  const y = Number(month.slice(0, 4));
  const m = Number(month.slice(5, 7));
  const lastYear = Math.max(Number(current.slice(0, 4)) + 1, y);
  const years: number[] = [];
  for (let i = Math.min(YEAR_MIN, y); i <= lastYear; i += 1) years.push(i);
  const set = (yy: number, mm: number): void => onMonth(`${yy}-${String(mm).padStart(2, "0")}`);
  const btn = "inline-flex size-8 items-center justify-center rounded-md border bg-background hover:bg-accent";
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label={label}>
      <button type="button" className={btn} aria-label="Предыдущий месяц" onClick={() => onMonth(shiftMonth(month, -1))}>
        <ChevronLeft className="size-4" aria-hidden />
      </button>
      <span className="min-w-36 text-center text-sm font-semibold" data-testid={testId}>
        {monthTitle(month)}
      </span>
      <button type="button" className={btn} aria-label="Следующий месяц" onClick={() => onMonth(shiftMonth(month, 1))}>
        <ChevronRight className="size-4" aria-hidden />
      </button>
      <select className={selectClass} aria-label="Месяц" value={m} onChange={(e) => set(y, Number(e.target.value))}>
        {MONTH_NAMES.map((n, i) => (
          <option key={n} value={i + 1}>
            {n}
          </option>
        ))}
      </select>
      <select className={selectClass} aria-label="Год" value={y} onChange={(e) => set(Number(e.target.value), m)}>
        {years.map((yy) => (
          <option key={yy} value={yy}>
            {yy}
          </option>
        ))}
      </select>
      <button
        type="button"
        disabled={month === current}
        onClick={() => onMonth(current)}
        className="h-8 rounded-md border bg-background px-3 text-xs hover:bg-accent disabled:opacity-50"
      >
        Текущий месяц
      </button>
    </div>
  );
}
